import React, { useState, useEffect, memo } from 'react';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';

// Componente Input con Debounce para evitar re-renders excesivos
export const DebouncedInput = memo(({ value, onChange, delay = 150, ...props }) => {
  const [localValue, setLocalValue] = useState(value || '');
  
  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      if (localValue !== value) {
        onChange({ target: { value: localValue } });
      }
    }, delay);
    return () => clearTimeout(timer);
  }, [localValue, delay, onChange, value]);
  
  return (
    <Input 
      {...props} 
      value={localValue} 
      onChange={(e) => setLocalValue(e.target.value)} 
    />
  );
});

DebouncedInput.displayName = 'DebouncedInput';

// Textarea con debounce
export const DebouncedTextarea = memo(({ value, onChange, delay = 150, ...props }) => {
  const [localValue, setLocalValue] = useState(value || '');
  
  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      if (localValue !== value) {
        onChange({ target: { value: localValue } });
      }
    }, delay);
    return () => clearTimeout(timer);
  }, [localValue, delay, onChange, value]);
  
  return (
    <Textarea 
      {...props} 
      value={localValue} 
      onChange={(e) => setLocalValue(e.target.value)} 
    />
  );
});

DebouncedTextarea.displayName = 'DebouncedTextarea';
